import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {editTag, fetchTag} from "../../../actions/connectionActions";
import TagForm from "./TagForm";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {ThemeProvider} from "@material-ui/core/styles";

import {theme} from '../../Dashboard/theme';
import Grid from "@material-ui/core/Grid";

let themeCustom = {
  ...theme,
};

const styles = theme => ({
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    padding: '15px',
    paddingTop: '40px',
    paddingBottom: '40px'
  },
  textField: {
    minWidth: "200px"
  },
  textArea: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize + 1,
    width: "100%"
  },
});

class TagEdit extends React.Component {

  componentDidMount() {
    this.props.fetchTag(this.props.match.params.id);
  }

  onSubmit = (formValues) => {
    this.props.editTag(this.props.match.params.id, formValues);
  };

  render() {
    const {classes} = this.props;
    if (_.isEmpty(this.props.tag)) {
      return null;
    } else {
      return (
        <ThemeProvider theme={themeCustom}>
          <Grid container maxWidth="xs" style={{
            maxHeight: "100vh",
            maxWidth: "100vw",
            display: "flex",
            flexDirection: "column"
          }}>
            <CssBaseline/>
            <Grid container justify="center">
              <Paper className={classes.paper}>
                <TagForm
                  initialValues={_.pick(this.props.tag, 'email', '_id')}
                  onSubmit={this.onSubmit}
                  classes={classes}
                />
              </Paper>
            </Grid>
          </Grid>
        </ThemeProvider>
      );
    }
  }
}


const mapStateToProps = (state) => {
  return {tag: state.tags.tag}
};

TagEdit = connect(mapStateToProps, {editTag, fetchTag})(TagEdit);
TagEdit = withStyles(styles)(TagEdit);
export default TagEdit;
